import * as fromCore from '@abovo/webvis-data-access';
import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { of } from 'rxjs';

@Injectable()
export class PreferencesGuard {
   constructor(private store: Store<fromCore.WebvisRouterState>) {}

   canActivate() {
      this.store.dispatch(new fromCore.LoadPreferences());
      return of(true);
   }
}
